<template>
  <v-container class="py-0" v-if="title">
    <v-layout row wrap v-if="icon || title" style="min-height:92px">
      <v-flex xs11 class="pb-0">
        <v-card flat>
          <v-card-text :class="classObject" style="padding-left: 0px;">
            <h1 class="page-headline hidden-sm-and-down">
              <!--<v-icon style="margin-bottom: 3px;" v-if="icon">{{ icon }}</v-icon>-->
              <span v-html="$t(title)"></span>
            </h1>
            <h4 class="headline hidden-md-and-up index-title">
              <!-- <v-icon v-if="icon" class="mb-1">{{ icon }}</v-icon> -->
              <span v-html="$t(title)"></span>
            </h4>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs1 v-if="tooltip" style="margin-top:30px">
        <v-tooltip max-width="320" bottom>
          <template #activator="data">
            <v-icon color="#d4d4d1" size="30" dark v-on="data.on">help_outline</v-icon>
          </template>
          <span>{{ $t(tooltip) }}</span>
        </v-tooltip>
      </v-flex>
    </v-layout>
    <div class="page-border"></div>
  </v-container>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    icon: {
      type: String
    },
    color: {
      type: String
    },
    alignment: {
      type: String
    }
  },
  data () {
    return {
      tooltip: null
    }
  },
  watch: {
    title () {
      this.setTooltip()
    }
  },
  mounted () {
    this.setTooltip()
  },
  computed: {
    classObject: function () {
      const defaultClasses = ' pb-0'
      return 'text-xs-left' + defaultClasses
    }
  },
  methods: {
    setTooltip () {
      if (this.title === 'sideBar.filters') {
        this.tooltip = 'howto.filter'
      } else if (this.title === 'sideBar.images') {
        this.tooltip = 'howto.images'
      } else if (this.title === 'sideBar.liveSchemes') {
        this.tooltip = 'howto.liveSchemes'
      } else if (this.title === 'sideBar.diagrams') {
        this.tooltip = 'howto.diagrams'
      } else if (this.title === 'sideBar.downloads') {
        this.tooltip = 'howto.downloads'
      } else if (this.title === 'visualization.scheduledDownloads') {
        this.tooltip = 'howto.reports'
      } else if (this.title === 'sideBar.reports') {
        this.tooltip = 'howto.extendedReports'
      } else if (this.title === 'sideBar.notifications') {
        this.tooltip = 'howto.monitoringNotification'
      } else if (this.title === 'monitoring.errorLog') {
        this.tooltip = 'howto.monitoringErrorlog'
      } else if (this.title === 'sideBar.parametrization') {
        this.tooltip = 'howto.parametrization'
      } else if (this.title === 'VBus® Data Viewer') {
        this.tooltip = 'dataviewer.title'
      } else if (this.title === 'settingsDocumentation.settingsDocumentationGenerator') {
        this.tooltip = 'settingsDocumentation.description'
      } else {
        this.tooltip = null
      }
    }
  }
}
</script>

<style scoped>
.page-headline {
  font-size: 30px !important;
  font-family: "Open Sans Regular", sans-serif !important;
  font-weight: 400 !important;
  line-height: 1 !important;
  letter-spacing: 0.02em !important;
}
.v-tooltip__content {
  text-align: left;
}

.page-border {
  opacity: 0.5;
  height: 1px;
  margin-bottom: 5px;
  background: rgba(105,105,105,1);
  background: -moz-linear-gradient(left, rgba(105,105,105,1) 0%, rgba(255,255,255,0.77) 81%, rgba(255,255,255,0.71) 100%);
  background: -webkit-gradient(left top, right top, color-stop(0%, rgba(105,105,105,1)), color-stop(81%, rgba(255,255,255,0.77)), color-stop(100%, rgba(255,255,255,0.71)));
  background: -webkit-linear-gradient(left, rgba(105,105,105,1) 0%, rgba(255,255,255,0.77) 81%, rgba(255,255,255,0.71) 100%);
  background: -o-linear-gradient(left, rgba(105,105,105,1) 0%, rgba(255,255,255,0.77) 81%, rgba(255,255,255,0.71) 100%);
  background: -ms-linear-gradient(left, rgba(105,105,105,1) 0%, rgba(255,255,255,0.77) 81%, rgba(255,255,255,0.71) 100%);
  background: linear-gradient(to right, rgba(105,105,105,1) 0%, rgba(255,255,255,0.77) 81%, rgba(255,255,255,0.71) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#696969', endColorstr='#ffffff', GradientType=1 );
}
.help-icon {
  cursor: pointer;
  /* color: blue; */
}
.help-icon:hover {
  opacity: .9;
}
</style>



// WEBPACK FOOTER //
// src/client/components/public/PageTitle.vue